import { useEffect } from "@wordpress/element";
import MenuItem from "@mui/material/MenuItem";
import { SelectField } from "vino/core";
import { useDispatch, useSelector } from "react-redux";
import { getCountryList } from "store/vino/lookupsSlice";

const Country = (props) => {
	const dispatch = useDispatch();
	const countryList = useSelector(({ vino }) => vino.lookups.countryList);

	useEffect(() => {
		if (countryList.length === 0) {
			dispatch(getCountryList());
		}
	}, [dispatch]);

	return (
		<SelectField {...props} fullWidth label="Country">
			<MenuItem value="">Select</MenuItem>
			{countryList.map((country) => (
				<MenuItem key={country.id} value={country.id}>
					{country.name}
				</MenuItem>
			))}
		</SelectField>
	);
};

export default Country;
